// §4.4 partial — admin/subscriptions routes.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const SubscriptionsLookupPage = lazyWithRetry(
  () => import("./pages/SubscriptionsLookupPage"),
);
const SubscriptionDetailPage = lazyWithRetry(
  () => import("./pages/SubscriptionDetailPage"),
);
const ManualSubscriptionPage = lazyWithRetry(
  () => import("./pages/ManualSubscriptionPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/subscriptions", Component: SubscriptionsLookupPage },
      {
        path: "/admin/subscriptions/lookup",
        Component: SubscriptionsLookupPage,
      },
      {
        path: "/admin/subscriptions/manual",
        Component: ManualSubscriptionPage,
      },
      { path: "/admin/subscriptions/:id", Component: SubscriptionDetailPage },
    ],
  },
];

export default routes;
